<template>
  <AppBanner icon="pepicons-print:people">
    {{ $tt('quantity') }}: 
    <QuantitySpan strong>
      {{ quantity }}
    </QuantitySpan>
  </AppBanner>
</template>

<script setup lang="ts">
defineProps<{
  quantity: number;
}>();
</script>